import { useRecoilValue } from 'recoil';
import { privateHouseAttributesInfoSelector } from '../recoil/selectors/attributeInfoSelector';
import type { ModalInfo } from '../config/modalConfig';
import type { OPCAttribute } from '../recoil/types/opcTypes';
import privateHouseAttributesConfig from '../pages/OpcEntryPage/config/house-config/privateHouseAttributesConfig';
import { useHippoText } from './useHippoText';

export interface HouseAttributeConfig {
    name: string;
    value: string;
    editable: boolean;
    willTriggerCallMeModal: boolean;
    opcAttribute?: OPCAttribute;
    hippoLabel: string;
    modalInformation?: ModalInfo;
}

const usePrhHouseOPC = (): { attributesConfig: HouseAttributeConfig[] } => {
    const attributes = useRecoilValue(privateHouseAttributesInfoSelector);
    const getHippoText = useHippoText();
    const attributesConfig = privateHouseAttributesConfig(attributes, getHippoText);
    return { attributesConfig };
};
export default usePrhHouseOPC;
